export const FILO1 = [
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Abril es el mes más cruel. Puros deseos y recuerdos de cosas que dábamos por sentadas unas semanas atrás.",
        className: "grs-1 gre-2 gcs-1 gce-6 center",
        delay: 2500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 2,
        type: "text",
        page: 0,
        text: "La lluvia de otoño rebota contra las veredas y es el único movimiento que hay allá afuera.",
        className: "grs-1 gre-2 gcs-1 gce-6 down",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 3,
        type: "img",
        page: 0,
        text: "",
        className: "grs-2 gre-5 gcs-1 gce-3",
        height: 230,
        delay: 4500, 
        renderNext: true,
        url: "/assets/img/plantachica.png",
        nextPage: false,
    },
    {
        id: 4,
        type: "text",
        page: 0,
        text: "Estamos envejeciendo en macetas de cemento porque ya no se puede plantar los pies en la tierra. ¿Qué clase de plantas puede crecer de estas cajas rígidas, sin poros, sin respiración?",
        className: "grs-2 gre-3 gcs-3 gce-7 center",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 5,
        type: "text",
        page: 0,
        text: "Pasamos todo el día levantando estatuas en nuestros espacios cerrados, construidas con las imágenes que todavía nos quedan:",
        className: "grs-3 gre-4 gcs-3 gce-7 center",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text:"El último día que fuimos en bici hasta el río.",
        className: "grs-4 gre-5 gcs-3 gce-7 up mb-0 right",
        delay: 7300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },  
    {   
        id: 7,
        type: "text",
        page: 0,
        text:"Conversaciones entre desconocidos escuchadas en el colectivo.",
        className: "grs-4 gre-5 gcs-3 gce-7 center right",
        delay: 4500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 8,
        type: "text",
        page: 0,
        text:"Frases que nos dijimos cuando nuestras voces todavía no nos sonaban extrañas.",
        className: "grs-4 gre-5 gcs-3 gce-7 down right",
        delay: 4500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 9,
        type: "text",
        page: 0,
        text:"Les damos forma a esos recuerdos para pasar el tiempo. Armamos exhibiciones que solo podemos visitar nosotros dos. Desde hace rato que ese es el único diálogo posible: pocas palabras, algunos gestos, toda una economía de la expresión.",   
        className: "grs-5 gre-6 gcs-1 gce-7 down",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text:"No hay nada humano en nuestro día a día excepto nosotros dos. La gente que vemos a través de la ventana es más irreal que los dibujitos que hay en la tele a la madrugada. Algunas tardes me cuesta diferenciar los ladridos de los perros, el sonido de los pájaros y los ecos de los nenes jugando en el balcón. Forman un loop que se repite con los días, como todo lo demás.",
        className: "grs-6 gre-7 gcs-1 gce-7 mb-0",
        delay: 12000, 
        renderNext: true,
        url: "",
        nextPage: true,
    }
];

export const FILO2 = [
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Estás bestialmente quieto. Hablame.",
        className: "grs-1 gre-2 gcs-3 gce-7 center",
        delay: 7500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 2,
        type: "text",
        page: 0,
        text: "¿Por qué no me hablás?",
        className: "grs-1 gre-2 gcs-3 gce-7 down",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 3,
        type: "text",
        page: 0,
        text: "Nunca sé qué estás pensando y a veces creo que no pensás en nada.",
        className: "grs-2 gre-3 gcs-3 gce-7 up",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 4,
        type: "text",
        page: 0,
        text: "¿Seguís vivo, acaso? ¿Sigo viva?",
        className: "grs-2 gre-3 gcs-3 gce-7 center",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 5,
        type: "text",
        page: 0,
        text:"¿Qué vamos a hacer ahora?",
        className: "grs-2 gre-3 gcs-3 gce-7 down mb-0",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text:"Me paro frente a la ventana. Busco la mirada de alguien, cualquiera. Ojos que me den cuerpo. Pero la gente ya no sale de sus cajas.",
        className: "grs-3 gre-4 gcs-3 gce-7 center",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 7,
        type: "text",
        page: 0,
        text:"Quiero correr por la calle. Nunca sospeché que alguna vez iba a tener este deseo intenso de correr por la calle, de sentir las baldosas bajo mis pies.",
        className: "grs-4 gre-5 gcs-3 gce-7 center",
        delay: 6500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 8,
        type: "text",
        page: 0,
        text:"A la noche veo ratas rondando las veredas vacías. No hay nadie para reclamar esos espacios.",   
        className: "grs-5 gre-6 gcs-3 gce-7 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 9,
        type: "img",
        page: 0,
        text: "",
        className: "grs-1 gre-7 gcs-1 gce-3 center",
        height: 450,
        delay: 1500, 
        renderNext: true,
        url: "/assets/img/rata.png",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text:"Ellas andan embriagadas con esa nueva libertad.",   
        className: "grs-5 gre-6 gcs-3 gce-7 center",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 11,
        type: "text",
        page: 0,
        text:"Ya tomaron la ciudad, y no opusimos resistencia. Las miramos desde el otro lado del vidrio.",
        className: "grs-6 gre-7 gcs-3 gce-7 up",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 12,
        type: "text",
        page: 0,
        text:"Miles de ojos observando todo desde sus ventanas, testigos de una época en la cual ya no hay protagonistas.",
        className: "grs-6 gre-7 gcs-3 gce-7 down ",
        delay: 5000, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
];

export const FILO3 = [
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Me siento desconectada.",
        className: "grs-1 gre-2 gcs-1 gce-3 up",
        delay: 0, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 2,
        type: "img",
        page: 0,
        text: "",
        className: "gcs-5 gce-7 grs-1 gre-4",
        height: 200,
        delay: 1000, 
        renderNext: true,
        url: "/assets/img/espejo2.png",
        nextPage: false,
    },
    {
        id: 3,
        type: "text",
        page: 0,
        text: "Mis pies están en la cama, y debajo de ellos mi corazón.",
        className: "grs-1 gre-2 gcs-1 gce-4 center mb-0",
        delay: 2500, //animate__delay-1s
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 5,
        type: "text",
        page: 0,
        text:"Mi",
        className: "gcs-1 gce-3 grs-2 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text:"cabeza ",
        className: "gcs-1 gce-3 grs-2 up rueda-cabeza",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 7,
        type: "text",
        page: 0,
        text: " r ",
        className: "gcs-1 gce-3 grs-2 up left rueda-r",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 8,
        type: "text",
        page: 0,
        text: " u ",
        className: "gcs-1 gce-3 grs-2 up left rueda-u",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 9,
        type: "text",
        page: 0,
        text: " e ",
        className: "gcs-1 gce-3 grs-2 up left rueda-e",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text: " d ",
        className: "gcs-1 gce-3 grs-2 up left rueda-d",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 11,
        type: "text",
        page: 0,
        text: " a ",
        className: "gcs-1 gce-3 grs-2 up left rueda-a",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 12,
        type: "text",
        page: 0,
        text: " debajo del sillón ",
        className: "gcs-2 gce-3 grs-2 up pl-1",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 13,
        type: "text",
        page: 0,
        text: "y encuentra la carta que perdí hace meses.",
        className: "gcs-2 gce-5 grs-2 up center-hori encuentra",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 14,
        type: "text",
        page: 0,
        text: "Me prometiste que hoy iba a ser un día nuevo, pero no sé si lo dijiste ayer o la semana pasada. ",
        className: "gcs-1 gce-7 grs-2 down left",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 15,
        type: "text",
        page: 0,
        text: "No puedo conectar ",
        className: "gcs-1 gce-7 grs-3 up left",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 16,
        type: "text",
        page: 0,
        text: "nada",
        className: "gcs-1 gce-7 grs-3 up left nada1",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 17,
        type: "text",
        page: 0,
        text: "con",
        className: "gcs-1 gce-7 grs-3 up left con",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 18,
        type: "text",
        page: 0,
        text: "nada.",
        className: "gcs-1 gce-7 grs-3 up left nada2",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 19,
        type: "text",
        page: 0,
        text: "Me inunda la idea fija de una casa en llamas y no tener adónde escapar.",
        className: "gcs-4 gce-7 grs-4 center left",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 20,
        type: "img",
        page: 0,
        text: "",
        className: "gcs-1 gce-4 grs-4 gre-7",
        height: 230,
        delay: 500, 
        renderNext: true,
        url: "/assets/img/sillon.png",
        nextPage: false,
    },
    {   
        id: 21,
        type: "text",
        page: 0,
        text: "La casa se quema,",
        className: "gcs-4 gce-7 grs-4 down left",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 22,
        type: "text",
        page: 0,
        text: "se quema,",
        className: "gcs-4 gce-7 grs-4 down left sequema2",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 23,
        type: "text",
        page: 0,
        text: "se quema,",
        className: "gcs-4 gce-7 grs-4 down left sequema3",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 24,
        type: "text",
        page: 0,
        text: "pero nadie se mueve.",
        className: "gcs-4 gce-7 grs-4 down left pero",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 25,
        type: "text",
        page: 0,
        text: "La gente de los balcones observa, y el humo  ",
        className: "gcs-4 gce-7 grs-6 center left",
        delay: 4300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 26,
        type: "text",
        page: 0,
        text: "sube",
        className: "gcs-6 gce-7 grs-6 up left-hori",
        delay: 2300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 27,
        type: "text",
        page: 0,
        text: "hasta",
        className: "gcs-6 gce-7 grs-5 down center-hori",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 28,
        type: "text",
        page: 0,
        text: "el cielo.",
        className: "gcs-6 gce-7 grs-5 up right",
        delay: 600, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
    
];

export const FILO4 = [
    {
        id: 0,
        type: "text",
        page: 0,
        text: "Hoy hace frío en estas torres irreales.",
        className: "grs-1 gre-2 gcs-1 gce-7 up",
        delay: 5500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Las plazas, los museos, los shoppings, las escuelas, están vacíos y derrumbándose. Son tierra de ratas ahora.",
        className: "grs-1 gre-2 gcs-1 gce-7 center",
        delay: 3000,
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 2,
        type: "text",
        page: 0,
        text: "La ciudad es un montón de ruinas olvidadas.",
        className: "grs-1 gre-2 gcs-1 gce-7 down",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 3,
        type: "img",
        page: 0,
        text: "",
        className: "gcs-1 gce-3 grs-2 gre-4 center center-hori",
        height: 150,
        delay: 1500,
        renderNext: true,
        url: "/assets/img/cuadros.png",
        nextPage: false,
    },
    {   
        id: 4,
        type: "text",
        page: 0,
        text:"Nosotros, adentro, miramos las pantallas. Nosotros, los vivos, muriendo con paciencia.",
        className: "grs-2 gre-3 gcs-3 gce-7 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 5,
        type: "text",
        page: 0,
        text: "Rompés el silencio para decirme que me acerque, que deje de apretar así los puños.",
        className: "gcs-3 gce-7 grs-2 gre-3 center",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text: "Siempre me parece ver a alguien detrás tuyo cuando te movés, pero es solo tu sombra.",
        className: "gcs-3 gce-7 grs-2 gre-3 down",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 7,
        type: "text",
        page: 0,
        text: "Estamos solos hace demasiado tiempo y dejamos ecos nuestros por toda la casa.",
        className: "gcs-3 gce-7 grs-3 gre-4 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 8,
        type: "img",
        page: 0,
        text: "",
        className: "gcs-4 gce-7 grs-3 gre-7 down left",
        height: 300,
        delay: 3000,
        renderNext: true,
        url: "/assets/img/cocina.png",
        nextPage: false,
    },
    {   
        id: 9,
        type: "text",
        page: 0,
        text: "Por fin va a llover esta tarde, se siente en el aire.",
        className: "gcs-3 gce-7 grs-3 gre-4 center",
        delay: 3200, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text: "Respiro ese olor húmedo y escucho el trueno a lo lejos. La lluvia muestra que ahí afuera el mundo gira todavía, sin que le importemos nosotros.",
        className: "gcs-1 gce-4 grs-4 gre-4 up",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 11,
        type: "text",
        page: 0,
        text: "El ambiente se refresca y se borra un poco nuestro olor. Pero la casa se sigue quemando en mi cabeza.",
        className: "gcs-1 gce-4 grs-5 gre-6 center",
        delay: 8000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 12,
        type: "text",
        page: 0,
        text: "La casa se quema,",
        className: "gcs-1 gce-5 grs-6 gre-7 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 13,
        type: "text",
        page: 0,
        text: "se quema,",
        className: "gcs-1 gce-5 grs-6 gre-7 up sequemaI",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, {   
        id: 14,
        type: "text",
        page: 0,
        text: "se quema.",
        className: "gcs-1 gce-5 grs-6 gre-7 up sequemaII",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 15,
        type: "text",
        page: 0,
        text: "Te digo que no, que no me quiero acercar.",
        className: "gcs-1 gce-5 grs-6 gre-7 center",
        delay: 2500, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
];

export const FILO5 = [
    {
        id: 0,
        type: "text",
        page: 0,
        text: "Desde que todo esto empezó, sueño con llaves. Las busco, pero nunca las encuentro ni en cajones ni en bolsillos ni en rincones.",
        className: "grs-1 gre-2 gcs-1 gce-7 center",
        delay: 7500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Te pregunto qué crees que significa soñar con llaves. Pensar en llaves suele confirmar jaulas, me explicó alguien alguna vez.",
        className: "grs-1 gre-2 gcs-1 gce-7 down",
        delay: 6000,
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 2,
        type: "text",
        page: 0,
        text:"La carta que encontré es el Colgado. Me decís que es una carta morbosa, que la deje de mirar. Yo te respondo que la soga no se enrosca en su cuello, sino en su pie. No tiene por qué ser una carta fatal. Es un símbolo de espera, de suspensión, de atadura. Ahí el mundo está dado vuelta, o nosotros lo miramos al revés.",
        className: "grs-2 gre-4 gcs-3 gce-7",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 3,
        type: "img",
        page: 0,
        text: "",
        className: "gcs-1 gce-3 grs-2 gre-7 up",
        height: 450,
        delay: 16000,
        renderNext: true,
        url: "/assets/img/colgado.png",
        nextPage: false,
    },
    {  
        id: 4,
        type: "text",
        page: 0,
        text: "Giro la cabeza para verlo mejor. El Colgado parece resignado. Él tampoco puede irse si las ramas se queman, se queman, se queman. Él se quema con ellas.",
        className: "gcs-3 gce-7 grs-3 gre-4 center",
        delay: 1000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 5,
        type: "text",
        page: 0,
        text: "Venís y me arrancás la carta de la mano. Doy un paso para atrás. Quiero alejarme más, pero no tengo dónde.",
        className: "gcs-3 gce-7 grs-4 gre-5 center",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text: "La casa se quema,",
        className: "gcs-3 gce-5 grs-5 gre-6 up",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 7,
        type: "text",
        page: 0,
        text: "se quema,",
        className: "gcs-3 gce-5 grs-5 gre-6 up sequemaI",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 8,
        type: "text",
        page: 0,
        text: "se quema.",
        className: "gcs-3 gce-5 grs-5 gre-6 up sequemaII",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 9,
        type: "text",
        page: 0,
        text: "Y las puertas siguen cerradas. No puedo salir.",
        className: "gcs-3 gce-7 grs-5 gre-6 up nopuedo",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text: "Mis pies hacia arriba, mi corazón en la escalera.",
        className: "gcs-3 gce-7 grs-5 gre-6 down",
        delay: 2500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 11,
        type: "text",
        page: 0,
        text: "Mi cabeza rueda, sin poder conectar",
        className: "gcs-3 gce-7 grs-6 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 12,
        type: "text",
        page: 0,
        text: "nada",
        className: "gcs-4 gce-7 grs-6 up left nada3",
        delay: 1000, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 13,
        type: "text",
        page: 0,
        text: "con",
        className: "gcs-4 gce-7 grs-6 up left con2",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 14,
        type: "text",
        page: 0,
        text: "nada.",
        className: "gcs-4 gce-7 grs-6 up left nada4",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 15,
        type: "text",
        page: 0,
        text: "Pienso en Filomena, la hija de Atenas. Yo también quiero convertirme en pájaro.",
        className: "gcs-3 gce-7 grs-6 gre-7 down",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
];

export const FILOMENA = [
    /********************************   PAGINA 1 IDs[0-11]   ****************************************/
    {   
        id: 500,
        type: "text",
        page: 0,
        text: "",
        className: "",
        delay: 0, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 0,
        type: "audio",
        page: 0,
        text: "",
        className: "",
        delay: 1000, 
        renderNext: true,
        url: "/assets/sounds/aprilIsTheCruelest.mp3",
        nextPage: false,
    },
    {
        id: 1,
        type: "text",
        page: 0,
        text: "Abril es el mes más cruel. Puros deseos y recuerdos de cosas que dábamos por sentadas unas semanas atrás.",
        className: "grs-1 gre-2 gcs-1 gce-6 center",
        delay: 2500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 2,
        type: "text",
        page: 0,
        text: "La lluvia de otoño rebota contra las veredas y es el único movimiento que hay allá afuera.",
        className: "grs-1 gre-2 gcs-1 gce-6 down",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 3,
        type: "img",
        page: 0,
        text: "",
        className: "grs-2 gre-5 gcs-1 gce-3",
        height: 230,
        delay: 4500, 
        renderNext: true,
        url: "/assets/img/plantachica.png",
        nextPage: false,
    },
    {
        id: 4,
        type: "text",
        page: 0,
        text: "Estamos envejeciendo en macetas de cemento porque ya no se puede plantar los pies en la tierra. ¿Qué clase de plantas puede crecer de estas cajas rígidas, sin poros, sin respiración?",
        className: "grs-2 gre-3 gcs-3 gce-7 center",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 5,
        type: "text",
        page: 0,
        text: "Pasamos todo el día levantando estatuas en nuestros espacios cerrados, construidas con las imágenes que todavía nos quedan:",
        className: "grs-3 gre-4 gcs-3 gce-7 center",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 6,
        type: "text",
        page: 0,
        text:"El último día que fuimos en bici hasta el río.",
        className: "grs-4 gre-5 gcs-3 gce-7 up mb-0 right",
        delay: 7300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },  
    {   
        id: 7,
        type: "text",
        page: 0,
        text:"Conversaciones entre desconocidos escuchadas en el colectivo.",
        className: "grs-4 gre-5 gcs-3 gce-7 center right",
        delay: 4500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 8,
        type: "text",
        page: 0,
        text:"Frases que nos dijimos cuando nuestras voces todavía no nos sonaban extrañas.",
        className: "grs-4 gre-5 gcs-3 gce-7 down right",
        delay: 4500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 9,
        type: "text",
        page: 0,
        text:"Les damos forma a esos recuerdos para pasar el tiempo. Armamos exhibiciones que solo podemos visitar nosotros dos. Desde hace rato que ese es el único diálogo posible: pocas palabras, algunos gestos, toda una economía de la expresión.",   
        className: "grs-5 gre-6 gcs-1 gce-7 down",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 10,
        type: "text",
        page: 0,
        text:"No hay nada humano en nuestro día a día excepto nosotros dos. La gente que vemos a través de la ventana es más irreal que los dibujitos que hay en la tele a la madrugada. Algunas tardes me cuesta diferenciar los ladridos de los perros, el sonido de los pájaros y los ecos de los nenes jugando en el balcón. Forman un loop que se repite con los días, como todo lo demás.",
        className: "grs-6 gre-7 gcs-1 gce-7 mb-0",
        delay: 12000, 
        renderNext: true,
        url: "",
        nextPage: true,
    },
    {
        id: 11,
        type: "audio",
        page: 0,
        text: "",
        className: "",
        delay: 4000, 
        renderNext: false,
        url: "/assets/sounds/nenes.mp3",
        nextPage: true,
    },
    /********************************   PAGINA 2 IDs[12-24]   ****************************************/ 
    {   
        id: 12,
        type: "audio",
        page: 1,
        text: "",
        className: "",
        delay: 0, 
        renderNext: true,
        url: "/assets/sounds/whatAreYouThinking.mp3",
        nextPage: false,
    },
    {
        id: 13,
        type: "text",
        page: 1,
        text: "Estás bestialmente quieto. Hablame.",
        className: "grs-1 gre-2 gcs-3 gce-7 center",
        delay: 7500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 14,
        type: "text",
        page: 1,
        text: "¿Por qué no me hablás?",
        className: "grs-1 gre-2 gcs-3 gce-7 down",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 15,
        type: "text",
        page: 1,
        text: "Nunca sé qué estás pensando y a veces creo que no pensás en nada.",
        className: "grs-2 gre-3 gcs-3 gce-7 up",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 16,
        type: "text",
        page: 1,
        text: "¿Seguís vivo, acaso? ¿Sigo viva?",
        className: "grs-2 gre-3 gcs-3 gce-7 center",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 17,
        type: "text",
        page: 1,
        text:"¿Qué vamos a hacer ahora?",
        className: "grs-2 gre-3 gcs-3 gce-7 down mb-0",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 18,
        type: "text",
        page: 1,
        text:"Me paro frente a la ventana. Busco la mirada de alguien, cualquiera. Ojos que me den cuerpo. Pero la gente ya no sale de sus cajas.",
        className: "grs-3 gre-4 gcs-3 gce-7 center",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 19,
        type: "text",
        page: 1,
        text:"Quiero correr por la calle. Nunca sospeché que alguna vez iba a tener este deseo intenso de correr por la calle, de sentir las baldosas bajo mis pies.",
        className: "grs-4 gre-5 gcs-3 gce-7 center",
        delay: 6500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 20,
        type: "text",
        page: 1,
        text:"A la noche veo ratas rondando las veredas vacías. No hay nadie para reclamar esos espacios.",   
        className: "grs-5 gre-6 gcs-3 gce-7 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 21,
        type: "img",
        page: 1,
        text: "",
        className: "grs-1 gre-7 gcs-1 gce-3 center",
        height: 450,
        delay: 1500, 
        renderNext: true,
        url: "/assets/img/rata.png",
        nextPage: false,
    },
    {   
        id: 22,
        type: "text",
        page: 1,
        text:"Ellas andan embriagadas con esa nueva libertad.",   
        className: "grs-5 gre-6 gcs-3 gce-7 center",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 23,
        type: "text",
        page: 1,
        text:"Ya tomaron la ciudad, y no opusimos resistencia. Las miramos desde el otro lado del vidrio.",
        className: "grs-6 gre-7 gcs-3 gce-7 up",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 24,
        type: "text",
        page: 1,
        text:"Miles de ojos observando todo desde sus ventanas, testigos de una época en la cual ya no hay protagonistas.",
        className: "grs-6 gre-7 gcs-3 gce-7 down ",
        delay: 5000, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
    /********************************   PAGINA 3 IDs[25-49]   ****************************************/ 
    {   
        id: 100,
        type: "audio",
        page: 2,
        text: "",
        className: "",
        delay: 0, 
        renderNext: true,
        url: "/assets/sounds/burning.mp3",
        nextPage: false,
    },
    {
        id: 25,
        type: "text",
        page: 2,
        text: "Me siento desconectada.",
        className: "grs-1 gre-2 gcs-1 gce-3 up",
        delay: 4500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 26,
        type: "img",
        page: 2,
        text: "",
        className: "gcs-5 gce-7 grs-1 gre-4",
        height: 200,
        delay: 1000, 
        renderNext: true,
        url: "/assets/img/espejo2.png",
        nextPage: false,
    },
    {
        id: 27,
        type: "text",
        page: 2,
        text: "Mis pies están en la cama, y debajo de ellos mi corazón.",
        className: "grs-1 gre-2 gcs-1 gce-4 center mb-0",
        delay: 2500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 29,
        type: "text",
        page: 2,
        text:"Mi",
        className: "gcs-1 gce-3 grs-2 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 30,
        type: "text",
        page: 2,
        text:"cabeza ",
        className: "gcs-1 gce-3 grs-2 up rueda-cabeza",
        delay: 0, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 31,
        type: "text",
        page: 2,
        text: " r ",
        className: "gcs-1 gce-3 grs-2 up left rueda-r",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 32,
        type: "text",
        page: 2,
        text: " u ",
        className: "gcs-1 gce-3 grs-2 up left rueda-u",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 33,
        type: "text",
        page: 2,
        text: " e ",
        className: "gcs-1 gce-3 grs-2 up left rueda-e",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 34,
        type: "text",
        page: 2,
        text: " d ",
        className: "gcs-1 gce-3 grs-2 up left rueda-d",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 35,
        type: "text",
        page: 2,
        text: " a ",
        className: "gcs-1 gce-3 grs-2 up left rueda-a",
        delay: 300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 36,
        type: "text",
        page: 2,
        text: "debajo del sillón ",
        className: "gcs-2 gce-3 grs-2 up pl-1",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 37,
        type: "text",
        page: 2,
        text: "y encuentra la carta que perdí hace meses.",
        className: "gcs-2 gce-5 grs-2 up center-hori encuentra",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 38,
        type: "text",
        page: 2,
        text: "Me prometiste que hoy iba a ser un día nuevo, pero no sé si lo dijiste ayer o la semana pasada. ",
        className: "gcs-1 gce-7 grs-2 down left",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 39,
        type: "text",
        page: 2,
        text: "No puedo conectar ",
        className: "gcs-1 gce-7 grs-3 up left",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 40,
        type: "text",
        page: 2,
        text: "nada",
        className: "gcs-1 gce-7 grs-3 up left nada1",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 41,
        type: "text",
        page: 2,
        text: "con",
        className: "gcs-1 gce-7 grs-3 up left con",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 42,
        type: "text",
        page: 2,
        text: "nada.",
        className: "gcs-1 gce-7 grs-3 up left nada2",
        delay: 500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 43,
        type: "text",
        page: 2,
        text: "Me inunda la idea fija de una casa en llamas y no tener adónde escapar.",
        className: "gcs-4 gce-7 grs-4 center left",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 44,
        type: "img",
        page: 2,
        text: "",
        className: "gcs-1 gce-4 grs-4 gre-7",
        height: 230,
        delay: 1000, 
        renderNext: true,
        url: "/assets/img/sillon.png",
        nextPage: false,
    },
    {   
        id: 121,
        type: "text",
        page: 2,
        text: "La casa se quema,",
        className: "gcs-4 gce-7 grs-4 down left",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 122,
        type: "text",
        page: 2,
        text: "se quema,",
        className: "gcs-4 gce-7 grs-4 down left sequema2",
        delay: 1500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 123,
        type: "text",
        page: 2,
        text: "se quema,",
        className: "gcs-4 gce-7 grs-4 down left sequema3",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 124,
        type: "text",
        page: 2,
        text: "pero nadie se mueve.",
        className: "gcs-4 gce-7 grs-4 down left pero",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 46,
        type: "text",
        page: 2,
        text: "La gente de los balcones observa, y el humo  ",
        className: "gcs-4 gce-7 grs-6 center left",
        delay: 4300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 47,
        type: "text",
        page: 2,
        text: "sube",
        className: "gcs-6 gce-7 grs-6 up left-hori",
        delay: 2300, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 48,
        type: "text",
        page: 2,
        text: "hasta",
        className: "gcs-6 gce-7 grs-5 down center-hori",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 49,
        type: "text",
        page: 2,
        text: "el cielo.",
        className: "gcs-6 gce-7 grs-5 up right",
        delay: 600, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
    /********************************   PAGINA 4 IDs[50-66]   ****************************************/ 
    {   
        id: 50,
        type: "audio",
        page: 3,
        text: "",
        className: "",
        delay: 100, //animate__delay-1s
        renderNext: true,
        url: "/assets/sounds/third.mp3",
        nextPage: false,
    },
    {
        id: 51,
        type: "text",
        page: 3,
        text: "Hoy hace frío en estas torres irreales.",
        className: "grs-1 gre-2 gcs-1 gce-7 up",
        delay: 5500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 52,
        type: "text",
        page: 3,
        text: "Las plazas, los museos, los shoppings, las escuelas, están vacíos y derrumbándose. Son tierra de ratas ahora.",
        className: "grs-1 gre-2 gcs-1 gce-7 center",
        delay: 3000,
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 53,
        type: "text",
        page: 3,
        text: "La ciudad es un montón de ruinas olvidadas.",
        className: "grs-1 gre-2 gcs-1 gce-7 down",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 54,
        type: "img",
        page: 3,
        text: "",
        className: "gcs-1 gce-3 grs-2 gre-4 center center-hori",
        height: 150,
        delay: 1500,
        renderNext: true,
        url: "/assets/img/cuadros.png",
        nextPage: false,
    },
    {   
        id: 55,
        type: "text",
        page: 3,
        text:"Nosotros, adentro, miramos las pantallas. Nosotros, los vivos, muriendo con paciencia.",
        className: "grs-2 gre-3 gcs-3 gce-7 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 56,
        type: "text",
        page: 3,
        text: "Rompés el silencio para decirme que me acerque, que deje de apretar así los puños.",
        className: "gcs-3 gce-7 grs-2 gre-3 center",
        delay: 4000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 57,
        type: "text",
        page: 3,
        text: "Siempre me parece ver a alguien detrás tuyo cuando te movés, pero es solo tu sombra.",
        className: "gcs-3 gce-7 grs-2 gre-3 down",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 58,
        type: "text",
        page: 3,
        text: "Estamos solos hace demasiado tiempo y dejamos ecos nuestros por toda la casa.",
        className: "gcs-3 gce-7 grs-3 gre-4 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 59,
        type: "img",
        page: 3,
        text: "",
        className: "gcs-4 gce-7 grs-3 gre-7 down left",
        height: 300,
        delay: 3000,
        renderNext: true,
        url: "/assets/img/cocina.png",
        nextPage: false,
    },
    {   
        id: 60,
        type: "text",
        page: 3,
        text: "Por fin va a llover esta tarde, se siente en el aire.",
        className: "gcs-3 gce-7 grs-3 gre-4 center",
        delay: 3200, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 61,
        type: "text",
        page: 3,
        text: "Respiro ese olor húmedo y escucho el trueno a lo lejos. La lluvia muestra que ahí afuera el mundo gira todavía, sin que le importemos nosotros.",
        className: "gcs-1 gce-4 grs-4 gre-4 up",
        delay: 5000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 62,
        type: "text",
        page: 3,
        text: "El ambiente se refresca y se borra un poco nuestro olor. Pero la casa se sigue quemando en mi cabeza.",
        className: "gcs-1 gce-4 grs-5 gre-6 center",
        delay: 8000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 63,
        type: "text",
        page: 3,
        text: "La casa se quema,",
        className: "gcs-1 gce-5 grs-6 gre-7 up",
        delay: 6000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 64,
        type: "text",
        page: 3,
        text: "se quema,",
        className: "gcs-1 gce-5 grs-6 gre-7 up sequemaI",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 65,
        type: "text",
        page: 3,
        text: "se quema.",
        className: "gcs-1 gce-5 grs-6 gre-7 up sequemaII",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 66,
        type: "text",
        page: 3,
        text: "Te digo que no, que no me quiero acercar.",
        className: "gcs-1 gce-5 grs-6 gre-7 center",
        delay: 2500, 
        renderNext: false,
        url: "",
        nextPage: true,
    },
    /********************************   PAGINA 5 IDs[67-85]   ****************************************/ 
    {   
        id: 67,
        type: "audio",
        page: 4,
        text: "",
        className: "",
        delay: 100, //animate__delay-1s
        renderNext: true,
        url: "/assets/sounds/key.mp3",
        nextPage: false,
    },
    {
        id: 68,
        type: "text",
        page: 4,
        text: "Desde que todo esto empezó, sueño con llaves. Las busco, pero nunca las encuentro ni en cajones ni en bolsillos ni en rincones.",
        className: "grs-1 gre-2 gcs-1 gce-7 center",
        delay: 7500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {
        id: 69,
        type: "text",
        page: 4,
        text: "Te pregunto qué crees que significa soñar con llaves. Pensar en llaves suele confirmar jaulas, me explicó alguien alguna vez.",
        className: "grs-1 gre-2 gcs-1 gce-7 down",
        delay: 6000,
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 70,
        type: "text",
        page: 4,
        text:"La carta que encontré es el Colgado. Me decís que es una carta morbosa, que la deje de mirar. Yo te respondo que la soga no se enrosca en su cuello, sino en su pie. No tiene por qué ser una carta fatal. Es un símbolo de espera, de suspensión, de atadura. Ahí el mundo está dado vuelta, o nosotros lo miramos al revés.",
        className: "grs-2 gre-4 gcs-3 gce-7",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 71,
        type: "img",
        page: 4,
        text: "",
        className: "gcs-1 gce-3 grs-2 gre-7 up",
        height: 450,
        delay: 16000,
        renderNext: true,
        url: "/assets/img/colgado.png",
        nextPage: false,
    },
    {   
        id: 72,
        type: "text",
        page: 4,
        text: "Giro la cabeza para verlo mejor. El Colgado parece resignado. Él tampoco puede irse si las ramas se queman, se queman, se queman. Él se quema con ellas.",
        className: "gcs-3 gce-7 grs-3 gre-4 center",
        delay: 1000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 73,
        type: "text",
        page: 4,
        text: "Venís y me arrancás la carta de la mano. Doy un paso para atrás. Quiero alejarme más, pero no tengo dónde.",
        className: "gcs-3 gce-7 grs-4 gre-5 center",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 74,
        type: "text",
        page: 4,
        text: "La casa se quema,",
        className: "gcs-3 gce-5 grs-5 gre-6 up",
        delay: 7000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 75,
        type: "text",
        page: 4,
        text: "se quema,",
        className: "gcs-3 gce-5 grs-5 gre-6 up sequemaI",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 76,
        type: "text",
        page: 4,
        text: "se quema.",
        className: "gcs-3 gce-5 grs-5 gre-6 up sequemaII",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 77,
        type: "text",
        page: 4,
        text: "Y las puertas siguen cerradas. No puedo salir.",
        className: "gcs-3 gce-7 grs-5 gre-6 up nopuedo",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
   
    {   
        id: 78,
        type: "text",
        page: 4,
        text: "Mis pies hacia arriba, mi corazón en la escalera.",
        className: "gcs-3 gce-7 grs-5 gre-6 down",
        delay: 2500, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 79,
        type: "text",
        page: 4,
        text: "Mi cabeza rueda, sin poder conectar",
        className: "gcs-3 gce-7 grs-6 up",
        delay: 3000, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 80,
        type: "text",
        page: 4,
        text: "nada",
        className: "gcs-4 gce-7 grs-6 up left nada3",
        delay: 1000, 
        renderNext: true,
        url: "",
        nextPage: false,
    }, 
    {   
        id: 81,
        type: "text",
        page: 4,
        text: "con",
        className: "gcs-4 gce-7 grs-6 up left con2",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 82,
        type: "text",
        page: 4,
        text: "nada.",
        className: "gcs-4 gce-7 grs-6 up left nada4",
        delay: 600, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 83,
        type: "text",
        page: 4,
        text: "Pienso en Filomena, la hija de Atenas. Yo también quiero convertirme en pájaro.",
        className: "gcs-3 gce-7 grs-6 gre-7 down",
        delay: 800, 
        renderNext: true,
        url: "",
        nextPage: false,
    },
    {   
        id: 84,
        type: "audio",
        page: 4,
        text: "",
        className: "",
        delay: 2000, //animate__delay-1s
        renderNext: true,
        url: "/assets/sounds/Wellnow.mp3",
        nextPage: false,
    },
    {   
        id: 85,
        type: "audio",
        page: 4,
        text: "",
        className: "",
        delay: 5000, //animate__delay-1s
        renderNext: false,
        url: "/assets/sounds/Goodnight.mp3",
        nextPage: true,
    },
];